import React from 'react'
import { CollectionDetails } from 'components/SACollection'
import useCollectionLayout from '../hooks/useCollectionLayout'
import Fallback from 'components/SA/Fallback'
import { DEFAULT_APP } from '../helpers/constants'

const CollectionLayout = () => {
  const {
    artworks,
    collectionData,
    collectionOwnerId,
    algoliaIndice,
    adminUrlLinks,
    isCollectionPrivate,
    isCollectionPrintView,
    hasValidPermissions,
    urlPathString,
    isSet,
  } = useCollectionLayout()

  if (isCollectionPrivate && !hasValidPermissions && isSet) {
    return <Fallback subTitle='The collection you requested is private.' description='' title='' />
  }

  return (
    <CollectionDetails
      nextAppRoute={DEFAULT_APP}
      artworks={artworks}
      collectionTitle={collectionData.title}
      collectionDescription={collectionData.description}
      collectionOwnerName={collectionData.ownerName}
      collectionOwnerAvatarUrl={collectionData.ownerAvatar}
      collectionOwnerId={collectionOwnerId}
      collectionCount={collectionData.count}
      isCollectionPrintView={isCollectionPrintView}
      ownerTitle={collectionData.ownerTitle}
      idUserCollection={collectionData.idUserCollection}
      algoliaIndice={algoliaIndice}
      adminUrlLinks={adminUrlLinks}
      urlPathString={urlPathString}
    />
  )
}

export default CollectionLayout
